import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { MaintenanceWindowSelectorDataProviderFactory } from '../factory/MaintenanceWindowSelectorDataProviderFactory';
import { MaintenanceWindowSelectorBaseDataProvider } from '../dataProvider/MaintenanceWindowSelectorBaseDataProvider';
import { MaintenanceWindowSelectorWebComponentSchema } from '../types';

export class MaintenanceWindowSelectorRepository extends BaseWebComponentRepository {
  public dataProviderFactory: MaintenanceWindowSelectorDataProviderFactory;
  public dataProvider: MaintenanceWindowSelectorBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new MaintenanceWindowSelectorDataProviderFactory(),
    });
  }

  async getDataForView(
    type: number,
    companyId: string,
    selectedMaintenanceWindowId: string
  ): Promise<MaintenanceWindowSelectorWebComponentSchema> {
    return this.dataProvider.getDataForView(type, companyId, selectedMaintenanceWindowId);
  }
}
